<template>
    <div class="task ml-2 relative" :class="{active: isActive}">
        <div class="d-flex" v-if="editTask && editTask._id == task._id">
            <input
                class="input-task pt-3 pl-3 roboto-normal-18 clr-black-38 text-wrap"
                v-model="name"
                required
                autofocus
            >
            <div class="absolute roboto-normal-14 clr-black-38 complete" @click="renameMobileTask()">ОК</div>
        </div>
        <div v-else class="pt-3 pl-3 roboto-normal-14 clr-white name" @touchstart="selectTask" v-long-touch="handleLongTouch">
            {{task.name}}
            <div class="decorator" v-show="isActive"></div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        name: 'TaskMobile',
        data() {
            return {
                name: '',
            }
        },
        props: ['task', 'handleLongTouch', 'editTask'],
        computed:{
            ...mapGetters(["current", "current_task", "themes"]),
            isActive() {
                return this.current_task && (this.current_task._id == this.task._id)
            }
        },
        methods:{
            ...mapActions(['renameTask']),
            renameMobileTask() {
                this.renameTask({_id: this.current._id, task_id: this.task._id, name: this.name}).then(() => {
                    this.$emit("renameTask")
                })
            },
            selectTask() {
                this.$emit("selectTask")
            }
        },
        mounted() {
            this.name = this.editTask.name
        }
    }
</script>

<style lang="scss" scoped>
    .task {
        width: 117px;
        height: 72px;
        background: #18A0FB;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
        border-radius: 6px;
        white-space: normal;
        .name{
            max-height: 80%;
            overflow: hidden;
        }
        .decorator {
            position: absolute;
            width: 90%;
            height: 2px;
            background: white;
            left: 5%;
            bottom: 5px;
        }
        &.active {
            background: #0E85D5;
        }
        .input-task {
           width: auto;
           height: auto; 
           outline: none; 
        }
        .complete {
            bottom: 0;
            right: 5px;
        }
    }
</style>